module.exports = __webpack_public_path__ + "static/media/bgtop-product-red-ginseng.f9d86e56.jpg";